<template>
  <div class="measurement-units-selector" data-testid="measurement-units-container">
    <label>Patient Measurements:</label>
    <radio-buttons
      :options="options"
      :value="caseConf.measurementSystem"
      active-color="green-3"
      :disabled="readonly"
      @input="(measurementSystem) => updateMeasurementSystem(measurementSystem)"
    />
  </div>
</template>

<script>
import RadioButtons from '~lib/common/components/RadioButtons';

export default {
  name: 'measurement-units-selector',
  components: {
    RadioButtons
  },
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [
        {
          value: 'IMPERIAL',
          label: 'Imperial',
        },
        {
          value: 'METRIC',
          label: 'Metric',
        },
      ],
    };
  },
  methods: {
    updateMeasurementSystem(measurementSystem) {
      this.$emit('update', {
        measurementSystem,
      });
    },
  },
};
</script>

<style scoped>
label {
  display: block;
  line-height: normal;
  margin-bottom: 2px;
}
</style>